// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1nDiI","selected":"Chip_selected__1EdAl"};